var _style, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _polygon2, _path7, _path8, _path9, _path10, _path11, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _path12, _path13, _polygon15, _polygon16, _polygon17, _path14, _path15, _path16, _path17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _polygon63, _polygon64, _polygon65, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _path65, _path66, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _path67, _path68, _path69, _path70, _polygon102, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _circle, _g, _g2, _polygon109, _polygon110, _polygon111, _polygon112, _path79, _g3, _defs, _polygon113, _defs2, _polygon114, _defs3, _defs4, _defs5, _rect, _defs6, _rect2, _defs7, _defs8, _defs9, _rect3, _defs10, _defs11, _defs12, _rect4, _defs13, _defs14, _defs15, _polygon115, _circle2, _rect5, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:url(#SVGID_1_);} .st1{fill:url(#SVGID_2_);} .st2{fill:url(#SVGID_3_);} .st3{fill:url(#SVGID_4_);} .st4{fill:url(#SVGID_5_);} .st5{fill:url(#SVGID_6_);} .st6{fill:url(#SVGID_7_);} .st7{fill:url(#SVGID_8_);} .st8{fill:url(#SVGID_9_);} .st9{fill:url(#SVGID_10_);} .st10{fill:url(#SVGID_11_);} .st11{fill:url(#SVGID_12_);} .st12{fill:url(#SVGID_13_);} .st13{fill:url(#SVGID_14_);} .st14{fill:url(#SVGID_15_);} .st15{fill:url(#SVGID_16_);} .st16{fill:url(#SVGID_17_);} .st17{fill:url(#SVGID_18_);} .st18{fill:url(#SVGID_19_);} .st19{fill:url(#SVGID_20_);} .st20{fill:url(#SVGID_21_);} .st21{fill:url(#SVGID_22_);} .st22{fill:url(#SVGID_23_);} .st23{fill:url(#SVGID_24_);} .st24{fill:url(#SVGID_25_);} .st25{fill:url(#SVGID_26_);} .st26{fill:url(#SVGID_27_);} .st27{fill:url(#SVGID_28_);} .st28{fill:url(#SVGID_29_);} .st29{fill:url(#SVGID_30_);} .st30{fill:url(#SVGID_31_);} .st31{fill:url(#SVGID_32_);} .st32{fill:url(#SVGID_33_);} .st33{fill:url(#SVGID_34_);} .st34{fill:url(#SVGID_35_);} .st35{fill:url(#SVGID_36_);} .st36{fill:url(#SVGID_37_);} .st37{fill:url(#SVGID_38_);} .st38{fill:url(#SVGID_39_);} .st39{fill:url(#SVGID_40_);} .st40{fill:url(#SVGID_41_);} .st41{fill:url(#SVGID_42_);} .st42{fill:url(#SVGID_43_);} .st43{fill:url(#SVGID_44_);} .st44{fill:url(#SVGID_45_);} .st45{fill:url(#SVGID_46_);} .st46{fill:url(#SVGID_47_);} .st47{fill:url(#SVGID_48_);} .st48{fill:url(#SVGID_49_);} .st49{fill:url(#SVGID_50_);} .st50{fill:url(#SVGID_51_);} .st51{fill:url(#SVGID_52_);} .st52{fill:url(#SVGID_53_);} .st53{fill:url(#SVGID_54_);} .st54{fill:url(#SVGID_55_);} .st55{fill:url(#SVGID_56_);} .st56{fill:url(#SVGID_57_);} .st57{fill:url(#SVGID_58_);} .st58{fill:url(#SVGID_59_);} .st59{fill:url(#SVGID_60_);} .st60{fill:url(#SVGID_61_);} .st61{fill:url(#SVGID_62_);} .st62{fill:url(#SVGID_63_);} .st63{fill:url(#SVGID_64_);} .st64{fill:url(#SVGID_65_);} .st65{fill:url(#SVGID_66_);} .st66{fill:url(#SVGID_67_);} .st67{fill:url(#SVGID_68_);} .st68{fill:url(#SVGID_69_);} .st69{fill:url(#SVGID_70_);} .st70{fill:url(#SVGID_71_);} .st71{fill:url(#SVGID_72_);} .st72{fill:url(#SVGID_73_);} .st73{fill:url(#SVGID_74_);} .st74{fill:url(#SVGID_75_);} .st75{fill:url(#SVGID_76_);} .st76{fill:url(#SVGID_77_);} .st77{fill:url(#SVGID_78_);} .st78{fill:url(#SVGID_79_);} .st79{fill:url(#SVGID_80_);} .st80{fill:url(#SVGID_81_);} .st81{fill:url(#SVGID_82_);} .st82{fill:url(#SVGID_83_);} .st83{fill:url(#SVGID_84_);} .st84{fill:url(#SVGID_85_);} .st85{fill:url(#SVGID_86_);} .st86{fill:url(#SVGID_87_);} .st87{fill:url(#SVGID_88_);} .st88{fill:url(#SVGID_89_);} .st89{fill:url(#SVGID_90_);} .st90{fill:url(#SVGID_91_);} .st91{fill:url(#SVGID_92_);} .st92{fill:url(#SVGID_93_);} .st93{fill:url(#SVGID_94_);} .st94{fill:url(#SVGID_95_);} .st95{fill:url(#SVGID_96_);} .st96{fill:url(#SVGID_97_);} .st97{fill:url(#SVGID_98_);} .st98{fill:url(#SVGID_99_);} .st99{fill:url(#SVGID_100_);} .st100{fill:url(#SVGID_101_);} .st101{fill:url(#SVGID_102_);} .st102{fill:url(#SVGID_103_);} .st103{fill:url(#SVGID_104_);} .st104{fill:url(#SVGID_105_);} .st105{fill:url(#SVGID_106_);} .st106{fill:url(#SVGID_107_);} .st107{fill:url(#SVGID_108_);} .st108{fill:url(#SVGID_109_);} .st109{fill:url(#SVGID_110_);} .st110{fill:url(#SVGID_111_);} .st111{fill:url(#SVGID_112_);} .st112{fill:url(#SVGID_113_);} .st113{fill:url(#SVGID_114_);} .st114{fill:url(#SVGID_115_);} .st115{fill:url(#SVGID_116_);} .st116{fill:url(#SVGID_117_);} .st117{fill:url(#SVGID_118_);} .st118{fill:url(#SVGID_119_);} .st119{fill:url(#SVGID_120_);} .st120{fill:url(#SVGID_121_);} .st121{fill:url(#SVGID_122_);} .st122{fill:url(#SVGID_123_);} .st123{fill:url(#SVGID_124_);} .st124{fill:url(#SVGID_125_);} .st125{fill:url(#SVGID_126_);} .st126{fill:url(#SVGID_127_);} .st127{fill:url(#SVGID_128_);} .st128{fill:url(#SVGID_129_);} .st129{fill:url(#SVGID_130_);} .st130{fill:url(#SVGID_131_);} .st131{fill:url(#SVGID_132_);} .st132{fill:url(#SVGID_133_);} .st133{fill:url(#SVGID_134_);} .st134{fill:url(#SVGID_135_);} .st135{fill:url(#SVGID_136_);} .st136{fill:url(#SVGID_137_);} .st137{fill:url(#SVGID_138_);} .st138{fill:url(#SVGID_139_);} .st139{fill:url(#SVGID_140_);} .st140{fill:url(#SVGID_141_);} .st141{fill:url(#SVGID_142_);} .st142{fill:url(#SVGID_143_);} .st143{fill:url(#SVGID_144_);} .st144{fill:url(#SVGID_145_);} .st145{fill:url(#SVGID_146_);} .st146{fill:url(#SVGID_147_);} .st147{fill:url(#SVGID_148_);} .st148{fill:url(#SVGID_149_);} .st149{fill:url(#SVGID_150_);} .st150{fill:url(#SVGID_151_);} .st151{fill:url(#SVGID_152_);} .st152{fill:url(#SVGID_153_);} .st153{fill:url(#SVGID_154_);} .st154{fill:url(#SVGID_155_);} .st155{fill:url(#SVGID_156_);} .st156{fill:url(#SVGID_157_);} .st157{fill:url(#SVGID_158_);} .st158{fill:url(#SVGID_159_);} .st159{fill:url(#SVGID_160_);} .st160{fill:url(#SVGID_161_);} .st161{fill:url(#SVGID_162_);} .st162{fill:url(#SVGID_163_);} .st163{fill:url(#SVGID_164_);} .st164{fill:url(#SVGID_165_);} .st165{fill:url(#SVGID_166_);} .st166{fill:url(#SVGID_167_);} .st167{fill:url(#SVGID_168_);} .st168{fill:url(#SVGID_169_);} .st169{fill:url(#SVGID_170_);} .st170{fill:url(#SVGID_171_);} .st171{fill:url(#SVGID_172_);} .st172{fill:url(#SVGID_173_);} .st173{fill:url(#SVGID_174_);} .st174{fill:url(#SVGID_175_);} .st175{fill:url(#SVGID_176_);} .st176{fill:url(#SVGID_177_);} .st177{fill:url(#SVGID_178_);} .st178{fill:url(#SVGID_179_);} .st179{fill:url(#SVGID_180_);} .st180{fill:url(#SVGID_181_);} .st181{fill:url(#SVGID_182_);} .st182{fill:url(#SVGID_183_);} .st183{fill:url(#SVGID_184_);} .st184{fill:url(#SVGID_185_);} .st185{fill:url(#SVGID_186_);} .st186{fill:#FFFFFF;} .st187{fill:url(#SVGID_187_);} .st188{fill:url(#SVGID_188_);} .st189{fill:#58A145;} .st190{fill:#87BE03;} .st191{fill:url(#SVGID_189_);} .st192{clip-path:url(#SVGID_191_);fill:url(#SVGID_192_);} .st193{clip-path:url(#SVGID_194_);fill:url(#SVGID_195_);} .st194{clip-path:url(#SVGID_197_);} .st195{clip-path:url(#SVGID_199_);} .st196{clip-path:url(#SVGID_201_);fill:url(#SVGID_202_);} .st197{clip-path:url(#SVGID_204_);fill:url(#SVGID_205_);} .st198{clip-path:url(#SVGID_207_);} .st199{clip-path:url(#SVGID_209_);} .st200{clip-path:url(#SVGID_211_);fill:url(#SVGID_212_);} .st201{clip-path:url(#SVGID_214_);} .st202{clip-path:url(#SVGID_216_);} .st203{clip-path:url(#SVGID_218_);fill:url(#SVGID_219_);} .st204{clip-path:url(#SVGID_221_);} .st205{clip-path:url(#SVGID_223_);} .st206{clip-path:url(#SVGID_225_);fill:url(#SVGID_226_);} .st207{fill:none;} .st208{fill:url(#SVGID_227_);} .st209{fill:#035875;} .st210{fill:url(#SVGID_228_);} .st211{fill:url(#SVGID_229_);} .st212{fill:url(#SVGID_230_);} .st213{fill:url(#SVGID_231_);} .st214{fill:url(#SVGID_232_);} .st215{fill:url(#SVGID_233_);} .st216{fill:url(#SVGID_234_);} .st217{fill:url(#SVGID_235_);} .st218{fill:url(#SVGID_236_);} .st219{fill:url(#SVGID_237_);} .st220{fill:url(#SVGID_238_);} .st221{fill:url(#SVGID_239_);} .st222{fill:url(#SVGID_240_);} .st223{fill:url(#SVGID_241_);} .st224{fill:url(#SVGID_242_);} .st225{fill:url(#SVGID_243_);} .st226{fill:url(#SVGID_244_);} .st227{fill:url(#SVGID_245_);} .st228{fill:url(#SVGID_246_);} .st229{fill:url(#SVGID_247_);} .st230{fill:url(#SVGID_248_);} .st231{fill:url(#SVGID_249_);} .st232{fill:url(#SVGID_250_);} .st233{fill:url(#SVGID_251_);} .st234{fill:url(#SVGID_252_);} .st235{fill:url(#SVGID_253_);} .st236{fill:url(#SVGID_254_);} .st237{fill:url(#SVGID_255_);} .st238{fill:url(#SVGID_256_);} .st239{fill:url(#SVGID_257_);} .st240{fill:url(#SVGID_258_);} .st241{fill:url(#SVGID_259_);} .st242{fill:url(#SVGID_260_);} .st243{fill:url(#SVGID_261_);} .st244{fill:url(#SVGID_262_);} .st245{fill:url(#SVGID_263_);} .st246{fill:url(#SVGID_264_);} .st247{fill:url(#SVGID_265_);} .st248{fill:url(#SVGID_266_);} .st249{fill:url(#SVGID_267_);} .st250{fill:url(#SVGID_268_);} .st251{fill:url(#SVGID_269_);} .st252{fill:url(#SVGID_270_);} .st253{fill:url(#SVGID_271_);} .st254{fill:url(#SVGID_272_);} .st255{fill:url(#SVGID_273_);} .st256{fill:url(#SVGID_274_);} .st257{fill:url(#SVGID_275_);} .st258{fill:url(#SVGID_276_);} .st259{fill:url(#SVGID_277_);} .st260{fill:url(#SVGID_278_);} .st261{fill:url(#SVGID_279_);} .st262{fill:url(#SVGID_280_);} .st263{fill:url(#SVGID_281_);} .st264{fill:url(#SVGID_282_);} .st265{fill:url(#SVGID_283_);} .st266{fill:url(#SVGID_284_);} .st267{fill:url(#SVGID_285_);} .st268{fill:url(#SVGID_286_);} .st269{fill:url(#SVGID_287_);} .st270{fill:url(#SVGID_288_);} .st271{fill:url(#SVGID_289_);} .st272{fill:url(#SVGID_290_);} .st273{fill:url(#SVGID_291_);} .st274{fill:url(#SVGID_292_);} .st275{fill:url(#SVGID_293_);} .st276{fill:url(#SVGID_294_);} .st277{fill:url(#SVGID_295_);} .st278{fill:url(#SVGID_296_);} .st279{fill:url(#SVGID_297_);} .st280{fill:url(#SVGID_298_);} .st281{fill:url(#SVGID_299_);} .st282{fill:url(#SVGID_300_);} .st283{fill:url(#SVGID_301_);} .st284{fill:url(#SVGID_302_);} .st285{fill:url(#SVGID_303_);} .st286{fill:url(#SVGID_304_);} .st287{fill:url(#SVGID_305_);} .st288{fill:url(#SVGID_306_);} .st289{fill:url(#SVGID_307_);} .st290{fill:url(#SVGID_308_);} .st291{fill:url(#SVGID_309_);} .st292{fill:url(#SVGID_310_);} .st293{fill:url(#SVGID_311_);} .st294{fill:url(#SVGID_312_);} .st295{fill:url(#SVGID_313_);} .st296{fill:url(#SVGID_314_);} .st297{fill:url(#SVGID_315_);} .st298{fill:url(#SVGID_316_);} .st299{fill:url(#SVGID_317_);} .st300{fill:url(#SVGID_318_);} .st301{fill:url(#SVGID_319_);} .st302{fill:url(#SVGID_320_);} .st303{fill:url(#SVGID_321_);} .st304{fill:url(#SVGID_322_);} .st305{fill:url(#SVGID_323_);} .st306{fill:url(#SVGID_324_);} .st307{fill:url(#SVGID_325_);} .st308{fill:url(#SVGID_326_);} .st309{fill:url(#SVGID_327_);} .st310{fill:url(#SVGID_328_);} .st311{fill:url(#SVGID_329_);} .st312{fill:url(#SVGID_330_);} .st313{fill:url(#SVGID_331_);} .st314{fill:url(#SVGID_332_);} .st315{fill:url(#SVGID_333_);} .st316{fill:url(#SVGID_334_);} .st317{fill:url(#SVGID_335_);} .st318{fill:url(#SVGID_336_);} .st319{fill:url(#SVGID_337_);} .st320{fill:url(#SVGID_338_);} .st321{fill:url(#SVGID_339_);} .st322{fill:url(#SVGID_340_);} .st323{fill:url(#SVGID_341_);} .st324{fill:url(#SVGID_342_);} .st325{fill:url(#SVGID_343_);} .st326{fill:url(#SVGID_344_);} .st327{fill:url(#SVGID_345_);} .st328{fill:url(#SVGID_346_);} .st329{fill:url(#SVGID_347_);} .st330{fill:url(#SVGID_348_);} .st331{fill:url(#SVGID_349_);} .st332{fill:url(#SVGID_350_);} .st333{fill:url(#SVGID_351_);} .st334{fill:url(#SVGID_352_);} .st335{fill:url(#SVGID_353_);} .st336{fill:url(#SVGID_354_);} .st337{fill:url(#SVGID_355_);} .st338{fill:url(#SVGID_356_);} .st339{fill:url(#SVGID_357_);} .st340{fill:url(#SVGID_358_);} .st341{fill:url(#SVGID_359_);} .st342{fill:url(#SVGID_360_);} .st343{fill:url(#SVGID_361_);} .st344{fill:url(#SVGID_362_);} .st345{fill:url(#SVGID_363_);} .st346{fill:url(#SVGID_364_);} .st347{fill:url(#SVGID_365_);} .st348{fill:url(#SVGID_366_);} .st349{fill:url(#SVGID_367_);} .st350{fill:url(#SVGID_368_);} .st351{fill:url(#SVGID_369_);} .st352{fill:url(#SVGID_370_);} .st353{fill:url(#SVGID_371_);} .st354{fill:url(#SVGID_372_);} .st355{fill:url(#SVGID_373_);} .st356{fill:url(#SVGID_374_);} .st357{fill:url(#SVGID_375_);} .st358{fill:url(#SVGID_376_);} .st359{fill:url(#SVGID_377_);} .st360{fill:url(#SVGID_378_);} .st361{fill:url(#SVGID_379_);} .st362{fill:url(#SVGID_380_);} .st363{fill:url(#SVGID_381_);} .st364{fill:url(#SVGID_382_);} .st365{fill:url(#SVGID_383_);} .st366{fill:url(#SVGID_384_);} .st367{fill:url(#SVGID_385_);} .st368{fill:url(#SVGID_386_);} .st369{fill:url(#SVGID_387_);} .st370{fill:url(#SVGID_388_);} .st371{fill:url(#SVGID_389_);} .st372{fill:url(#SVGID_390_);} .st373{fill:url(#SVGID_391_);} .st374{fill:url(#SVGID_392_);} .st375{fill:url(#SVGID_393_);} .st376{fill:url(#SVGID_394_);} .st377{fill:url(#SVGID_395_);} .st378{fill:url(#SVGID_396_);} .st379{fill:url(#SVGID_397_);} .st380{fill:url(#SVGID_398_);} .st381{fill:url(#SVGID_399_);} .st382{fill:url(#SVGID_400_);} .st383{fill:url(#SVGID_401_);} .st384{fill:url(#SVGID_402_);} .st385{fill:url(#SVGID_403_);} .st386{fill:url(#SVGID_404_);} .st387{fill:url(#SVGID_405_);} .st388{fill:url(#SVGID_406_);} .st389{fill:url(#SVGID_407_);} .st390{fill:url(#SVGID_408_);} .st391{fill:url(#SVGID_409_);} .st392{fill:url(#SVGID_410_);} .st393{fill:url(#SVGID_411_);} .st394{fill:url(#SVGID_412_);} .st395{fill:url(#SVGID_413_);} .st396{fill:url(#SVGID_414_);} .st397{fill:url(#SVGID_415_);} .st398{fill:url(#SVGID_416_);} .st399{clip-path:url(#SVGID_418_);fill:url(#SVGID_419_);} .st400{clip-path:url(#SVGID_421_);fill:url(#SVGID_422_);} .st401{clip-path:url(#SVGID_424_);} .st402{clip-path:url(#SVGID_426_);} .st403{clip-path:url(#SVGID_428_);fill:url(#SVGID_429_);} .st404{clip-path:url(#SVGID_431_);fill:url(#SVGID_432_);} .st405{clip-path:url(#SVGID_434_);} .st406{clip-path:url(#SVGID_436_);} .st407{clip-path:url(#SVGID_438_);fill:url(#SVGID_439_);} .st408{clip-path:url(#SVGID_441_);} .st409{clip-path:url(#SVGID_443_);} .st410{clip-path:url(#SVGID_445_);fill:url(#SVGID_446_);} .st411{clip-path:url(#SVGID_448_);} .st412{clip-path:url(#SVGID_450_);} .st413{clip-path:url(#SVGID_452_);fill:url(#SVGID_453_);} .st414{fill:url(#SVGID_454_);} ")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0295,
    x2: 789.6564,
    y2: -1221.0295,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.6,361.5c0.2-0.1,0.4-0.3,0.6-0.4c0.1-0.1,0.2-0.1,0.3-0.2C159.2,361.1,158.9,361.3,158.6,361.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0281,
    x2: 789.6564,
    y2: -1221.0281,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.2,361.1c0.1-0.1,0.2-0.1,0.3-0.2c0,0,0,0,0,0C159.4,360.9,159.3,361,159.2,361.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.4039,
    x2: 789.6564,
    y2: -1221.4039,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160.9,240.2c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0C160.8,240.1,160.8,240.2,160.9,240.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.408,
    x2: 789.6564,
    y2: -1221.408,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M160.5,239.8c-0.1-0.1-0.1-0.1-0.2-0.2C160.3,239.7,160.4,239.8,160.5,239.8 C160.5,239.8,160.5,239.8,160.5,239.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0201,
    x2: 789.6564,
    y2: -1221.0201,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M163.6,355.1C163.6,355.1,163.6,355.1,163.6,355.1c0.1-0.3,0.2-0.7,0.3-1c0,0,0,0,0,0 C163.8,354.4,163.7,354.8,163.6,355.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.4207,
    x2: 789.6564,
    y2: -1221.4207,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M159.3,238.9c-0.2-0.1-0.4-0.3-0.7-0.4C158.8,238.6,159.1,238.8,159.3,238.9 C159.3,238.9,159.3,238.9,159.3,238.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0193,
    x2: 788.9656,
    y2: -1221.0193,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "162,358.4 162,358.4 162,358.4 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0233,
    x2: 789.0685,
    y2: -1221.0233,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "160.6,360 160.6,360 160.6,360 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0184,
    x2: 789.6564,
    y2: -1221.0184,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M162.4,357.8c0.1-0.1,0.2-0.3,0.3-0.4c0,0,0,0,0,0C162.6,357.5,162.5,357.6,162.4,357.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0183,
    x2: 789.6564,
    y2: -1221.0183,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M163,356.6c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0,0,0,0C163.1,356.4,163.1,356.5,163,356.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 727.8201,
    y1: -1246.7441,
    x2: 728.8179,
    y2: -1246.7441,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M161.1,240.5c0,0-0.1-0.1-0.1-0.1C161,240.4,161.1,240.5,161.1,240.5L161.1,240.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.4113,
    x2: 789.6564,
    y2: -1221.4113,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M160.1,239.6C160.1,239.6,160.1,239.6,160.1,239.6c-0.1-0.1-0.2-0.1-0.2-0.2c0,0,0,0,0,0 C160,239.4,160,239.5,160.1,239.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 727.8201,
    y1: -1246.7374,
    x2: 729.1595,
    y2: -1246.7374,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M160.1,239.6C160.1,239.6,160.1,239.6,160.1,239.6c-0.1-0.1-0.2-0.1-0.2-0.2c0,0,0,0,0,0 C160,239.4,160,239.5,160.1,239.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4349,
    y1: -1246.7382,
    x2: 728.4524,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4319,
    y1: -1246.7382,
    x2: 728.4493,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4285,
    y1: -1246.7382,
    x2: 728.446,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4265,
    y1: -1246.7382,
    x2: 728.4439,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2171,
    y1: -1221.4124,
    x2: 788.2171,
    y2: -1221.4124,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "159.9,239.4 159.9,239.4 159.9,239.4 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2171,
    y1: -1221.4124,
    x2: 788.2171,
    y2: -1221.4124,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "159.9,239.4 159.9,239.4 159.9,239.4 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4376,
    y1: -1246.7367,
    x2: 728.449,
    y2: -1246.7367,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "159.9,239.4 159.9,239.4 159.9,239.4 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.417,
    x2: 789.6564,
    y2: -1221.417,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M159.5,239C159.5,239,159.5,239,159.5,239c-0.1,0-0.1-0.1-0.2-0.1c0,0,0,0,0,0 C159.3,238.9,159.4,239,159.5,239z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 727.8201,
    y1: -1246.7338,
    x2: 729.1595,
    y2: -1246.7338,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M159.5,239C159.5,239,159.5,239,159.5,239c-0.1,0-0.1-0.1-0.2-0.1c0,0,0,0,0,0 C159.3,238.9,159.4,239,159.5,239z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2164,
    y1: -1221.4161,
    x2: 788.2164,
    y2: -1221.4161,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "159.5,239 159.5,239 159.5,239 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2164,
    y1: -1221.4161,
    x2: 788.2164,
    y2: -1221.4161,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "159.5,239 159.5,239 159.5,239 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4268,
    y1: -1246.7343,
    x2: 728.4583,
    y2: -1246.7343,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "159.5,239 159.5,239 159.5,239 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.4059,
    x2: 789.6564,
    y2: -1221.4059,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M160.7,240.1C160.7,240.1,160.7,240.1,160.7,240.1c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0,0,0,0 C160.5,239.9,160.6,240,160.7,240.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 727.8201,
    y1: -1246.741,
    x2: 729.1595,
    y2: -1246.741,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M160.7,240.1C160.7,240.1,160.7,240.1,160.7,240.1c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0,0,0,0 C160.5,239.9,160.6,240,160.7,240.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.4012,
    x2: 789.6564,
    y2: -1221.4012,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M161.1,240.5c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0C161,240.4,161.1,240.5,161.1,240.5L161.1,240.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 727.8201,
    y1: -1246.7441,
    x2: 728.6107,
    y2: -1246.7441,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M161.1,240.5c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0C161,240.4,161.1,240.5,161.1,240.5L161.1,240.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4419,
    y1: -1246.7382,
    x2: 728.4454,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4419,
    y1: -1246.7382,
    x2: 728.4454,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4419,
    y1: -1246.7382,
    x2: 728.4454,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4419,
    y1: -1246.7382,
    x2: 728.4454,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4387,
    y1: -1246.7382,
    x2: 728.4476,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4387,
    y1: -1246.7382,
    x2: 728.4476,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4387,
    y1: -1246.7382,
    x2: 728.4476,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4406,
    y1: -1246.7382,
    x2: 728.4467,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4406,
    y1: -1246.7382,
    x2: 728.4467,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4406,
    y1: -1246.7382,
    x2: 728.4467,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4387,
    y1: -1246.7382,
    x2: 728.4448,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4387,
    y1: -1246.7382,
    x2: 728.4448,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4387,
    y1: -1246.7382,
    x2: 728.4448,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4382,
    y1: -1246.7382,
    x2: 728.4453,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4382,
    y1: -1246.7382,
    x2: 728.4453,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4403,
    y1: -1246.7382,
    x2: 728.447,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4403,
    y1: -1246.7382,
    x2: 728.447,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4382,
    y1: -1246.7382,
    x2: 728.4449,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.2176,
    y1: -1221.4102,
    x2: 788.2176,
    y2: -1221.4102,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.4382,
    y1: -1246.7382,
    x2: 728.4449,
    y2: -1246.7382,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "160.1,239.6 160.1,239.6 160.1,239.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.4026,
    x2: 789.6564,
    y2: -1221.4026,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M161,240.4c0,0-0.1-0.1-0.1-0.1C160.9,240.3,161,240.3,161,240.4C161,240.4,161,240.4,161,240.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.4026,
    x2: 789.6564,
    y2: -1221.4026,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M161,240.4c0,0-0.1-0.1-0.1-0.1C160.9,240.3,161,240.3,161,240.4C161,240.4,161,240.4,161,240.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 727.8201,
    y1: -1246.7432,
    x2: 728.9842,
    y2: -1246.7432,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M161,240.4c0,0-0.1-0.1-0.1-0.1C160.9,240.3,161,240.3,161,240.4C161,240.4,161,240.4,161,240.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.4094,
    x2: 789.6564,
    y2: -1221.4094,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M160.3,239.7c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0C160.2,239.6,160.2,239.6,160.3,239.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 727.8201,
    y1: -1246.7385,
    x2: 729.1595,
    y2: -1246.7385,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M160.3,239.7c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0C160.2,239.6,160.2,239.6,160.3,239.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.4094,
    x2: 789.6564,
    y2: -1221.4094,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M160.3,239.7c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0C160.2,239.6,160.2,239.6,160.3,239.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.4094,
    x2: 789.6564,
    y2: -1221.4094,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M160.3,239.7c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0C160.2,239.6,160.2,239.6,160.3,239.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 727.8201,
    y1: -1246.7385,
    x2: 729.1595,
    y2: -1246.7385,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M160.3,239.7c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0C160.2,239.6,160.2,239.6,160.3,239.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.4143,
    x2: 789.6564,
    y2: -1221.4143,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M159.9,239.4C159.9,239.4,159.9,239.4,159.9,239.4c-0.1-0.1-0.3-0.2-0.4-0.3c0,0,0,0,0,0 C159.6,239.1,159.7,239.2,159.9,239.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.4143,
    x2: 789.6564,
    y2: -1221.4143,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M159.9,239.4C159.9,239.4,159.9,239.4,159.9,239.4c-0.1-0.1-0.3-0.2-0.4-0.3c0,0,0,0,0,0 C159.6,239.1,159.7,239.2,159.9,239.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 727.8201,
    y1: -1246.7355,
    x2: 729.1595,
    y2: -1246.7355,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M159.9,239.4C159.9,239.4,159.9,239.4,159.9,239.4c-0.1-0.1-0.3-0.2-0.4-0.3c0,0,0,0,0,0 C159.6,239.1,159.7,239.2,159.9,239.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.3827,
    y1: -1265.3929,
    x2: 740.6725,
    y2: -1265.3929,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M163.9,354L163.9,354C163.9,354,163.9,354,163.9,354C163.9,354,163.9,354,163.9,354z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0192,
    x2: 789.6564,
    y2: -1221.0192,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M162,358.4c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0C162.1,358.3,162,358.3,162,358.4C162,358.4,162,358.4,162,358.4z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 739.2098,
    y1: -1265.4204,
    x2: 740.5493,
    y2: -1265.4204,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M162,358.4c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0C162.1,358.3,162,358.3,162,358.4C162,358.4,162,358.4,162,358.4z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0183,
    x2: 789.6564,
    y2: -1221.0183,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M162.7,357.4C162.7,357.4,162.7,357.4,162.7,357.4c0,0,0-0.1,0.1-0.1c0,0,0,0,0,0 C162.7,357.3,162.7,357.3,162.7,357.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 739.2098,
    y1: -1265.4139,
    x2: 740.5493,
    y2: -1265.4139,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M162.7,357.4C162.7,357.4,162.7,357.4,162.7,357.4c0,0,0-0.1,0.1-0.1c0,0,0,0,0,0 C162.7,357.3,162.7,357.3,162.7,357.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0182,
    x2: 789.4547,
    y2: -1221.0182,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M162.7,357.2C162.7,357.2,162.7,357.2,162.7,357.2C162.7,357.2,162.7,357.2,162.7,357.2 C162.7,357.2,162.7,357.2,162.7,357.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0182,
    x2: 789.4547,
    y2: -1221.0182,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M162.7,357.2C162.7,357.2,162.7,357.2,162.7,357.2C162.7,357.2,162.7,357.2,162.7,357.2 C162.7,357.2,162.7,357.2,162.7,357.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.2987,
    y1: -1265.4135,
    x2: 740.7419,
    y2: -1265.4135,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M162.7,357.2C162.7,357.2,162.7,357.2,162.7,357.2C162.7,357.2,162.7,357.2,162.7,357.2 C162.7,357.2,162.7,357.2,162.7,357.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0236,
    x2: 789.6564,
    y2: -1221.0236,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M160.5,360.1C160.5,360.1,160.5,360.1,160.5,360.1c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0 C160.6,360,160.5,360.1,160.5,360.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 739.2098,
    y1: -1265.4315,
    x2: 740.5493,
    y2: -1265.4315,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M160.5,360.1C160.5,360.1,160.5,360.1,160.5,360.1c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0 C160.6,360,160.5,360.1,160.5,360.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9605,
    y1: -1221.0237,
    x2: 789.0396,
    y2: -1221.0237,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "160.5,360.1 160.5,360.1 160.5,360.1 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9605,
    y1: -1221.0237,
    x2: 789.0396,
    y2: -1221.0237,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "160.5,360.1 160.5,360.1 160.5,360.1 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.4775,
    y1: -1265.4319,
    x2: 740.5342,
    y2: -1265.4319,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st102",
    points: "160.5,360.1 160.5,360.1 160.5,360.1 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0212,
    x2: 789.6564,
    y2: -1221.0212,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M161.3,359.2C161.3,359.2,161.3,359.2,161.3,359.2c0.2-0.3,0.5-0.5,0.7-0.8c-0.4,0.6-0.9,1.1-1.4,1.6 C160.9,359.7,161.1,359.5,161.3,359.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0212,
    x2: 789.6564,
    y2: -1221.0212,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M161.3,359.2C161.3,359.2,161.3,359.2,161.3,359.2c0.2-0.3,0.5-0.5,0.7-0.8c-0.4,0.6-0.9,1.1-1.4,1.6 C160.9,359.7,161.1,359.5,161.3,359.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 739.2098,
    y1: -1265.426,
    x2: 740.5493,
    y2: -1265.426,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M161.3,359.2C161.3,359.2,161.3,359.2,161.3,359.2c0.2-0.3,0.5-0.5,0.7-0.8c-0.4,0.6-0.9,1.1-1.4,1.6 C160.9,359.7,161.1,359.5,161.3,359.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0188,
    x2: 789.6564,
    y2: -1221.0188,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M162.1,358.2c0.1-0.2,0.2-0.3,0.3-0.5C162.3,357.9,162.2,358.1,162.1,358.2 C162.1,358.2,162.1,358.2,162.1,358.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 739.2098,
    y1: -1265.4185,
    x2: 740.5493,
    y2: -1265.4185,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M162.1,358.2c0.1-0.2,0.2-0.3,0.3-0.5C162.3,357.9,162.2,358.1,162.1,358.2 C162.1,358.2,162.1,358.2,162.1,358.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0188,
    x2: 789.6564,
    y2: -1221.0188,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M162.1,358.2c0.1-0.2,0.2-0.3,0.3-0.5C162.3,357.9,162.2,358.1,162.1,358.2 C162.1,358.2,162.1,358.2,162.1,358.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0188,
    x2: 789.6564,
    y2: -1221.0188,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M162.1,358.2c0.1-0.2,0.2-0.3,0.3-0.5C162.3,357.9,162.2,358.1,162.1,358.2 C162.1,358.2,162.1,358.2,162.1,358.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 739.2098,
    y1: -1265.4185,
    x2: 740.5493,
    y2: -1265.4185,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M162.1,358.2c0.1-0.2,0.2-0.3,0.3-0.5C162.3,357.9,162.2,358.1,162.1,358.2 C162.1,358.2,162.1,358.2,162.1,358.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.025,
    x2: 789.6564,
    y2: -1221.025,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M159.8,360.7c0.2-0.2,0.5-0.4,0.7-0.6c0,0,0,0,0,0C160.3,360.3,160,360.5,159.8,360.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_113_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.025,
    x2: 789.6564,
    y2: -1221.025,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M159.8,360.7c0.2-0.2,0.5-0.4,0.7-0.6c0,0,0,0,0,0C160.3,360.3,160,360.5,159.8,360.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_114_",
    gradientUnits: "userSpaceOnUse",
    x1: 739.2098,
    y1: -1265.4337,
    x2: 740.5493,
    y2: -1265.4337,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M159.8,360.7c0.2-0.2,0.5-0.4,0.7-0.6c0,0,0,0,0,0C160.3,360.3,160,360.5,159.8,360.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_115_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0266,
    x2: 789.6564,
    y2: -1221.0266,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M159.7,360.8c0,0,0.1-0.1,0.1-0.1C159.8,360.7,159.7,360.7,159.7,360.8C159.7,360.8,159.7,360.8,159.7,360.8 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_116_",
    gradientUnits: "userSpaceOnUse",
    x1: 739.2098,
    y1: -1265.4358,
    x2: 740.5493,
    y2: -1265.4358,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M159.7,360.8c0,0,0.1-0.1,0.1-0.1C159.8,360.7,159.7,360.7,159.7,360.8C159.7,360.8,159.7,360.8,159.7,360.8 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_117_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0266,
    x2: 789.6564,
    y2: -1221.0266,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M159.7,360.8c0,0,0.1-0.1,0.1-0.1C159.8,360.7,159.7,360.7,159.7,360.8C159.7,360.8,159.7,360.8,159.7,360.8 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_118_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0266,
    x2: 789.6564,
    y2: -1221.0266,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M159.7,360.8c0,0,0.1-0.1,0.1-0.1C159.8,360.7,159.7,360.7,159.7,360.8C159.7,360.8,159.7,360.8,159.7,360.8 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_119_",
    gradientUnits: "userSpaceOnUse",
    x1: 739.2098,
    y1: -1265.4358,
    x2: 740.5493,
    y2: -1265.4358,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M159.7,360.8c0,0,0.1-0.1,0.1-0.1C159.8,360.7,159.7,360.7,159.7,360.8C159.7,360.8,159.7,360.8,159.7,360.8 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_120_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0187,
    x2: 789.6564,
    y2: -1221.0187,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M163.2,356.3L163.2,356.3c0.1-0.3,0.2-0.6,0.4-1l0,0C163.4,355.6,163.3,355.9,163.2,356.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_121_",
    gradientUnits: "userSpaceOnUse",
    x1: 739.2098,
    y1: -1265.4041,
    x2: 740.5493,
    y2: -1265.4041,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M163.2,356.3L163.2,356.3c0.1-0.3,0.2-0.6,0.4-1l0,0C163.4,355.6,163.3,355.9,163.2,356.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_122_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0187,
    x2: 789.6564,
    y2: -1221.0187,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M163.2,356.3L163.2,356.3c0.1-0.3,0.2-0.6,0.4-1l0,0C163.4,355.6,163.3,355.9,163.2,356.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_123_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0187,
    x2: 789.6564,
    y2: -1221.0187,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M163.2,356.3L163.2,356.3c0.1-0.3,0.2-0.6,0.4-1l0,0C163.4,355.6,163.3,355.9,163.2,356.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_124_",
    gradientUnits: "userSpaceOnUse",
    x1: 739.2098,
    y1: -1265.4041,
    x2: 740.5493,
    y2: -1265.4041,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M163.2,356.3L163.2,356.3c0.1-0.3,0.2-0.6,0.4-1l0,0C163.4,355.6,163.3,355.9,163.2,356.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_125_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0182,
    x2: 789.6564,
    y2: -1221.0182,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M162.7,357.2c0.1-0.2,0.2-0.4,0.3-0.6C162.9,356.8,162.8,357,162.7,357.2 C162.7,357.2,162.7,357.2,162.7,357.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_126_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0182,
    x2: 789.6564,
    y2: -1221.0182,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M162.7,357.2c0.1-0.2,0.2-0.4,0.3-0.6C162.9,356.8,162.8,357,162.7,357.2 C162.7,357.2,162.7,357.2,162.7,357.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_127_",
    gradientUnits: "userSpaceOnUse",
    x1: 739.2098,
    y1: -1265.4115,
    x2: 740.5493,
    y2: -1265.4115,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M162.7,357.2c0.1-0.2,0.2-0.4,0.3-0.6C162.9,356.8,162.8,357,162.7,357.2 C162.7,357.2,162.7,357.2,162.7,357.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_128_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0272,
    x2: 789.6564,
    y2: -1221.0272,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M159.5,360.9c0,0,0.1-0.1,0.1-0.1C159.6,360.8,159.6,360.8,159.5,360.9C159.5,360.9,159.5,360.9,159.5,360.9 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_129_",
    gradientUnits: "userSpaceOnUse",
    x1: 739.2098,
    y1: -1265.4365,
    x2: 740.5493,
    y2: -1265.4365,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M159.5,360.9c0,0,0.1-0.1,0.1-0.1C159.6,360.8,159.6,360.8,159.5,360.9C159.5,360.9,159.5,360.9,159.5,360.9 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_130_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0269,
    x2: 789.0093,
    y2: -1221.0269,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_131_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.218,
    y1: -1265.4363,
    x2: 740.7831,
    y2: -1265.4363,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_132_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0269,
    x2: 789.0093,
    y2: -1221.0269,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st131",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_133_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.218,
    y1: -1265.4363,
    x2: 740.7831,
    y2: -1265.4363,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_134_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.997,
    y1: -1221.0269,
    x2: 789.0107,
    y2: -1221.0269,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st133",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_135_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.4933,
    y1: -1265.4362,
    x2: 740.5038,
    y2: -1265.4362,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_136_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9933,
    y1: -1221.0269,
    x2: 789.007,
    y2: -1221.0269,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "st135",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_137_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9933,
    y1: -1221.0269,
    x2: 789.007,
    y2: -1221.0269,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_138_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.4902,
    y1: -1265.4362,
    x2: 740.5007,
    y2: -1265.4362,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "st137",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_139_",
    gradientUnits: "userSpaceOnUse",
    x1: 789.0002,
    y1: -1221.0269,
    x2: 789.0139,
    y2: -1221.0269,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "st138",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_140_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.4954,
    y1: -1265.4362,
    x2: 740.5059,
    y2: -1265.4362,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "st139",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_141_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9965,
    y1: -1221.0269,
    x2: 789.0102,
    y2: -1221.0269,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "st140",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_142_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.4922,
    y1: -1265.4362,
    x2: 740.5027,
    y2: -1265.4362,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "st141",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_143_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9933,
    y1: -1221.0269,
    x2: 789.007,
    y2: -1221.0269,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "st142",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_144_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9933,
    y1: -1221.0269,
    x2: 789.007,
    y2: -1221.0269,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "st143",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_145_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.4902,
    y1: -1265.4362,
    x2: 740.5007,
    y2: -1265.4362,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_146_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.997,
    y1: -1221.0269,
    x2: 789.0107,
    y2: -1221.0269,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "st145",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_147_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.4933,
    y1: -1265.4362,
    x2: 740.5038,
    y2: -1265.4362,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "st146",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_148_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9933,
    y1: -1221.0269,
    x2: 789.007,
    y2: -1221.0269,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "st147",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_149_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9933,
    y1: -1221.0269,
    x2: 789.007,
    y2: -1221.0269,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "st148",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_150_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.4902,
    y1: -1265.4362,
    x2: 740.5007,
    y2: -1265.4362,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "st149",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_151_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9965,
    y1: -1221.0269,
    x2: 789.0102,
    y2: -1221.0269,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "st150",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_152_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.4922,
    y1: -1265.4362,
    x2: 740.5027,
    y2: -1265.4362,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "st151",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_153_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9933,
    y1: -1221.0269,
    x2: 789.007,
    y2: -1221.0269,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "st152",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_154_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9933,
    y1: -1221.0269,
    x2: 789.007,
    y2: -1221.0269,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "st153",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_155_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.4902,
    y1: -1265.4362,
    x2: 740.5007,
    y2: -1265.4362,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "st154",
    points: "159.7,360.8 159.7,360.8 159.7,360.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_156_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0183,
    x2: 789.6564,
    y2: -1221.0183,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M163.2,356.3C163.2,356.3,163.2,356.3,163.2,356.3C163.2,356.3,163.2,356.3,163.2,356.3 C163.2,356.3,163.2,356.3,163.2,356.3C163.2,356.3,163.2,356.3,163.2,356.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_157_",
    gradientUnits: "userSpaceOnUse",
    x1: 739.2098,
    y1: -1265.4075,
    x2: 740.5493,
    y2: -1265.4075,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st156",
    d: "M163.2,356.3C163.2,356.3,163.2,356.3,163.2,356.3C163.2,356.3,163.2,356.3,163.2,356.3 C163.2,356.3,163.2,356.3,163.2,356.3C163.2,356.3,163.2,356.3,163.2,356.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_158_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9542,
    y1: -1221.0183,
    x2: 788.9786,
    y2: -1221.0183,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "st157",
    points: "163.2,356.3 163.2,356.3 163.2,356.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_159_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.5202,
    y1: -1265.4072,
    x2: 740.5266,
    y2: -1265.4072,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "st158",
    points: "163.2,356.3 163.2,356.3 163.2,356.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_160_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9542,
    y1: -1221.0183,
    x2: 788.9786,
    y2: -1221.0183,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "st159",
    points: "163.2,356.3 163.2,356.3 163.2,356.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_161_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9542,
    y1: -1221.0183,
    x2: 788.9786,
    y2: -1221.0183,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "st160",
    points: "163.2,356.3 163.2,356.3 163.2,356.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_162_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.5202,
    y1: -1265.4072,
    x2: 740.5266,
    y2: -1265.4072,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "st161",
    points: "163.2,356.3 163.2,356.3 163.2,356.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_163_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0183,
    x2: 789.0128,
    y2: -1221.0183,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "st162",
    points: "163.2,356.3 163.2,356.3 163.2,356.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_164_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.4173,
    y1: -1265.4072,
    x2: 740.6295,
    y2: -1265.4072,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "st163",
    points: "163.2,356.3 163.2,356.3 163.2,356.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_165_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0183,
    x2: 789.0128,
    y2: -1221.0183,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "st164",
    points: "163.2,356.3 163.2,356.3 163.2,356.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_166_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0183,
    x2: 789.0128,
    y2: -1221.0183,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "st165",
    points: "163.2,356.3 163.2,356.3 163.2,356.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_167_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.4173,
    y1: -1265.4072,
    x2: 740.6295,
    y2: -1265.4072,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "st166",
    points: "163.2,356.3 163.2,356.3 163.2,356.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_168_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.021,
    x2: 789.6564,
    y2: -1221.021,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st167",
    d: "M163.9,354.1C163.9,354.1,163.9,354.1,163.9,354.1C163.9,354,163.9,354,163.9,354.1L163.9,354.1 C163.9,354,163.9,354.1,163.9,354.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_169_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.3007,
    y1: -1265.3931,
    x2: 740.7545,
    y2: -1265.3931,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M163.9,354.1C163.9,354.1,163.9,354.1,163.9,354.1C163.9,354,163.9,354,163.9,354.1L163.9,354.1 C163.9,354,163.9,354.1,163.9,354.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_170_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0192,
    x2: 789.6564,
    y2: -1221.0192,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M163.6,355.3C163.6,355.3,163.6,355.3,163.6,355.3c0-0.1,0-0.1,0.1-0.2c0,0,0,0,0,0 C163.6,355.2,163.6,355.2,163.6,355.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_171_",
    gradientUnits: "userSpaceOnUse",
    x1: 739.2098,
    y1: -1265.4003,
    x2: 740.5493,
    y2: -1265.4003,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M163.6,355.3C163.6,355.3,163.6,355.3,163.6,355.3c0-0.1,0-0.1,0.1-0.2c0,0,0,0,0,0 C163.6,355.2,163.6,355.2,163.6,355.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_172_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9415,
    y1: -1221.0192,
    x2: 788.9764,
    y2: -1221.0192,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "st171",
    points: "163.6,355.3 163.6,355.3 163.6,355.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_173_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.5204,
    y1: -1265.4009,
    x2: 740.5309,
    y2: -1265.4009,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "st172",
    points: "163.6,355.3 163.6,355.3 163.6,355.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_174_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9415,
    y1: -1221.0192,
    x2: 788.9764,
    y2: -1221.0192,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "st173",
    points: "163.6,355.3 163.6,355.3 163.6,355.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_175_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.5204,
    y1: -1265.4009,
    x2: 740.5309,
    y2: -1265.4009,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "st174",
    points: "163.6,355.3 163.6,355.3 163.6,355.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_176_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9415,
    y1: -1221.0192,
    x2: 788.9764,
    y2: -1221.0192,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "st175",
    points: "163.6,355.3 163.6,355.3 163.6,355.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_177_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9415,
    y1: -1221.0192,
    x2: 788.9764,
    y2: -1221.0192,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "st176",
    points: "163.6,355.3 163.6,355.3 163.6,355.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_178_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.5204,
    y1: -1265.4009,
    x2: 740.5309,
    y2: -1265.4009,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "st177",
    points: "163.6,355.3 163.6,355.3 163.6,355.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_179_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0192,
    x2: 789.6564,
    y2: -1221.0192,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M163.6,355.3C163.6,355.3,163.6,355.3,163.6,355.3C163.6,355.3,163.6,355.3,163.6,355.3 C163.6,355.3,163.6,355.3,163.6,355.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_180_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.3177,
    y1: -1265.4009,
    x2: 740.7336,
    y2: -1265.4009,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M163.6,355.3C163.6,355.3,163.6,355.3,163.6,355.3C163.6,355.3,163.6,355.3,163.6,355.3 C163.6,355.3,163.6,355.3,163.6,355.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_181_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0192,
    x2: 789.6564,
    y2: -1221.0192,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st180",
    d: "M163.6,355.3C163.6,355.3,163.6,355.3,163.6,355.3C163.6,355.3,163.6,355.3,163.6,355.3 C163.6,355.3,163.6,355.3,163.6,355.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_182_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.3156,
    y1: -1265.4009,
    x2: 740.7315,
    y2: -1265.4009,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st181",
    d: "M163.6,355.3C163.6,355.3,163.6,355.3,163.6,355.3C163.6,355.3,163.6,355.3,163.6,355.3 C163.6,355.3,163.6,355.3,163.6,355.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_183_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0192,
    x2: 789.6564,
    y2: -1221.0192,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st182",
    d: "M163.6,355.3C163.6,355.3,163.6,355.3,163.6,355.3C163.6,355.3,163.6,355.3,163.6,355.3 C163.6,355.3,163.6,355.3,163.6,355.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_184_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.317,
    y1: -1221.0192,
    x2: 789.6564,
    y2: -1221.0192,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st183",
    d: "M163.6,355.3C163.6,355.3,163.6,355.3,163.6,355.3C163.6,355.3,163.6,355.3,163.6,355.3 C163.6,355.3,163.6,355.3,163.6,355.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_185_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.3145,
    y1: -1265.4009,
    x2: 740.7305,
    y2: -1265.4009,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st184",
    d: "M163.6,355.3C163.6,355.3,163.6,355.3,163.6,355.3C163.6,355.3,163.6,355.3,163.6,355.3 C163.6,355.3,163.6,355.3,163.6,355.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_186_",
    gradientUnits: "userSpaceOnUse",
    x1: 300,
    y1: 6.1293,
    x2: 300,
    y2: 591.9725
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4A976A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0075C9"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st185",
    d: "M300,593.9c-39.6,0-78.1-7.8-114.4-23.1c-35-14.8-66.4-36-93.4-62.9c-27-27-48.1-58.4-62.9-93.4 C13.9,378.1,6.1,339.6,6.1,300s7.8-78.1,23.1-114.4c14.8-35,36-66.4,62.9-93.4c27-27,58.4-48.1,93.4-62.9 C221.9,13.9,260.4,6.1,300,6.1s78.1,7.8,114.4,23.1c35,14.8,66.4,36,93.4,62.9c27,27,48.1,58.4,62.9,93.4 c15.3,36.3,23.1,74.8,23.1,114.4c0,39.6-7.8,78.1-23.1,114.4c-14.8,35-36,66.4-62.9,93.4c-27,27-58.4,48.1-93.4,62.9 C378.1,586.1,339.6,593.9,300,593.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st186",
    cx: 300,
    cy: 300,
    r: 200.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M192.5,80c-4.4-11.4,1.2-22.8,11.9-26.9c10.8-4.2,22.6,0.4,27,11.8c4.4,11.4-1.2,22.8-12,26.9 C208.7,96,197,91.4,192.5,80z M227.3,66.5c-3.5-9-12.6-13.3-21.4-9.8c-8.8,3.4-12.7,12.7-9.2,21.7c3.5,9,12.6,13.3,21.4,9.9 C226.9,84.8,230.8,75.6,227.3,66.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M238,42.8l11.7-2.3c8.5-1.6,15,1.4,16.6,9.6c1.6,8.1-3.2,13.5-11.8,15.1l-7.5,1.4l2.9,15.1l-4.2,0.8 L238,42.8z M253.5,61.6c6.7-1.3,9.5-4.9,8.4-10.6c-1.1-5.8-5.1-8-11.8-6.7l-7.2,1.4l3.3,17.2L253.5,61.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M276.8,36.5l24.7-1.1l0.2,3.8l-20.4,0.9l0.6,14.5l18.2-0.8l0.2,3.8L282,58.4l0.6,14.7l21.3-0.9l0.2,3.8 l-25.5,1.1L276.8,36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M321.3,48.9c-0.9-1.4-2.2-3.7-2.3-4c0,0.3,0,3-0.2,4.6l-3.3,27.2l-4-0.5l4.9-40.8l0.7,0.1l20.7,31.4 c0.9,1.4,2.2,3.8,2.3,4.1c0-0.1,0-2.9,0.3-4.6l3.3-27.2l4,0.5l-4.9,40.8l-0.7-0.1L321.3,48.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M350,75.9l4-1.2c0.8,3,2.3,5.2,5.4,6.1c3.9,1.1,7-0.3,8.4-5.3l8.1-28.7l4.2,1.2L372,76.8 c-2,7.2-7.5,9.5-13.5,7.8C353.3,83.2,350.9,79.7,350,75.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M377.8,81.6l4-0.4c0.4,3.9,1.9,7.7,7.1,9.9c4.3,1.9,8.8,0.9,10.5-3.1c1.6-3.8,0.1-6.7-3.7-10.8l-2.4-2.6 c-4.3-4.7-6.1-8.5-3.9-13.7c2.3-5.4,8.1-7.2,13.7-4.8c5,2.1,7.1,5.8,7.7,9.9l-4,0.6c-0.4-2.9-1.7-5.5-5.2-7 c-3.7-1.6-6.8-0.4-8.2,2.8c-1.4,3.3-0.3,5.5,3.1,9.2l2.4,2.6c5,5.4,6.9,9.8,4.5,15.4c-2.6,6.2-9.1,7.8-15.8,4.9 C380.4,91.7,378.1,86.4,377.8,81.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M64,214.1c2.5-1.3,6.8-2.8,6.8-2.8s-4.4-0.9-7.2-1.8L47.5,204l2.5-7.4l38.8,13.3l-0.3,0.8l-24.8,13.2 c-2.4,1.3-6.8,2.7-6.8,2.7s4.5,1,7.2,1.9l16.1,5.5l-2.5,7.4l-38.8-13.3l0.3-0.8L64,214.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M56.1,242.9c11.9,1.7,19.3,12.2,17.7,23.8c-1.7,11.6-11.7,19.6-23.6,17.9c-11.9-1.7-19.3-12.2-17.7-23.8 C34.1,249.1,44.2,241.2,56.1,242.9z M51.3,276c7.5,1.1,14-3.1,15-10.4c1.1-7.3-4-13.1-11.5-14.2c-7.5-1.1-14,3.1-15,10.4 C38.8,269.1,43.8,274.9,51.3,276z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M70.4,292.2l0.5,12.5c0.5,12.5-7.5,21.7-19.5,22.1c-12,0.5-20.6-8.1-21.1-20.6l-0.5-12.5L70.4,292.2z M37.6,305.5c0.3,9,5.9,12.9,13.4,12.6c7.6-0.3,12.8-4.6,12.5-13.6l-0.1-3.7l-25.9,1L37.6,305.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M72.6,330.9l5.2,26.4l-7.2,1.4L67,340.5l-9.1,1.8l3.2,16l-7,1.4l-3.2-16l-9.3,1.8l3.7,19l-7.2,1.4 l-5.4-27.2L72.6,330.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M45.5,373.9c2.8-0.9,5.5,0.7,6.3,3.3c0.8,2.6-0.5,5.4-3.3,6.3c-2.9,0.9-5.5-0.7-6.3-3.3 C41.3,377.6,42.6,374.8,45.5,373.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M52.5,388.9l6.5,4.6c-1.6,2.1-3,4-1.8,6.6c1.1,2.5,2.8,3.7,6.6,2.1L89.8,391l3.3,7.7l-26.3,11.2 c-8,3.4-13.6,0.3-16.5-6.5C47.7,397.3,49.4,392.3,52.5,388.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M66,417.9l6.8,3.9c-1.6,3-2.3,6.1-0.2,9.7c1.7,3,4.4,4,6.4,2.8c2.5-1.4,2.2-3.9,1.7-8.1l-0.3-2.3 c-0.8-6.5,0-11.6,5.8-15c5.4-3.2,12-1.4,15.7,5c2.7,4.6,3,8.8,0.2,13.6l-6.9-3.5c1.5-2.5,1.6-4.4,0.4-6.5 c-1.2-2.1-3.4-2.7-5.1-1.7c-2.2,1.3-2.3,3.1-1.8,7l0.3,2.3c0.9,7.7,0.3,12.7-5.8,16.2c-6.5,3.8-13,0.8-17-6.1 C62.3,428.7,63,422.5,66,417.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M128.9,451.4l0.5,0.5l-18.1,41.2l-5.9-6.5l2.6-5.4l-10.5-11.8l-5.6,2l-5.4-6L128.9,451.4z M111.1,474.3 l2.9-6c1.2-2.6,3.5-6.3,3.8-6.6c-0.2,0.1-4.1,2-7,3l-6.3,2.2L111.1,474.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M144.2,468.1l11,9.1c6.4,5.3,9.1,12.8,3,20.1c-6,7.3-14,6.2-20.4,1l-4.6-3.8l-8.5,10.3l-6.5-5.3 L144.2,468.1z M142.4,492.5c3.2,2.6,6.4,2.9,9.2-0.6c2.9-3.5,1.9-6.6-1.2-9.1l-4.4-3.6l-8,9.7L142.4,492.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M170.7,489.3l12.3,7.3c7.1,4.3,10.9,11.3,6,19.4c-4.9,8.2-12.9,8.2-20,4l-5.1-3l-6.8,11.4l-7.2-4.3 L170.7,489.3z M172.5,513.6c3.5,2.1,6.7,1.9,9-2c2.3-3.9,0.9-6.8-2.6-8.8l-4.9-2.9l-6.5,10.8L172.5,513.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M200.2,506.2l7.7,3.2l-12.8,30.7l17,7.1l-2.8,6.8l-24.7-10.3L200.2,506.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M230.3,517.9l8,2.4l-11.7,38.9l-8-2.4L230.3,517.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M240.1,542.5c2-11.8,12.6-19,24.1-17c7.2,1.2,12,4.7,14.7,10.9l-7.1,3.4c-1.4-3.4-4.2-6.1-8.8-6.9 c-7.2-1.2-13.1,3.6-14.3,11s2.7,14,9.9,15.2c5.2,0.9,8.5-1.1,11.3-4.2l5.7,5.5c-4.4,4.8-10.5,7.3-18.2,6 C245.8,564.6,238.1,554.3,240.1,542.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M298.6,528.3l0.7,0l17.8,41.3l-8.8-0.2l-2.2-5.5l-15.8-0.3l-2.4,5.5L280,569L298.6,528.3z M303.3,556.9 l-2.5-6.2c-1.1-2.7-2.2-6.9-2.3-7.3c-0.1,0.2-1.3,4.4-2.5,7.2l-2.7,6.1L303.3,556.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M325.5,534.7l-11.5,1.4l-0.9-7.3l31.3-3.9l0.9,7.3l-11.5,1.4l4.1,33l-8.3,1L325.5,534.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M349.1,523.5l8.1-1.9l9.4,39.5l-8.1,1.9L349.1,523.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M370,540c-4.3-11.2,1.2-22.8,12.1-27s22.8,0.7,27.1,11.9c4.3,11.2-1.2,22.8-12.1,27 C386.2,556.1,374.3,551.2,370,540z M401.2,527.9c-2.7-7.1-9.5-10.7-16.4-8c-6.9,2.7-9.5,9.9-6.8,17c2.7,7.1,9.5,10.7,16.4,8 C401.4,542.2,404,535,401.2,527.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M427.7,515.6c-2.7-0.6-7-2.2-7-2.2s2.9,3.5,4.4,6l8.9,14.5l-6.7,4.1l-21.5-34.9l0.7-0.4l27.5,5.6 c2.7,0.5,7,2.2,7,2.2s-2.9-3.6-4.3-6l-8.9-14.5l6.7-4.1l21.5,34.9l-0.7,0.4L427.7,515.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M449.1,474.3l8.9-8.8c8.9-8.8,21.1-9.1,29.5-0.5c8.4,8.6,8,20.7-1,29.5l-8.9,8.8L449.1,474.3z M481,489.6 c6.4-6.3,5.6-13.1,0.3-18.5c-5.3-5.4-12-6.3-18.5,0l-2.6,2.6l18.2,18.5L481,489.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M476.3,446.6l16-21.6l5.9,4.4l-11,14.9l7.5,5.5l9.7-13.1l5.8,4.3l-9.7,13.1l7.6,5.6l11.5-15.6l5.9,4.4 l-16.5,22.3L476.3,446.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M494.1,422.9l4.2-7.9l17.1,1.1c3.6,0.3,9.1,1.4,9.6,1.5c-0.2-0.2-4.3-4-6.7-7l-10.7-13.3l3.8-7.2l27.9,34.9 l-0.4,0.7L494.1,422.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M512.4,386.7l8.7-25.4l7,2.4l-6,17.5l8.8,3l5.3-15.4l6.8,2.3l-5.3,15.4l8.9,3.1l6.3-18.3l6.9,2.4l-9,26.2 L512.4,386.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M522.8,354.8l1.6-8.2l32.7,6.2l3.4-18.1l7.2,1.4l-5,26.3L522.8,354.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M548.7,328.3c-12-0.4-20.6-9.9-20.2-21.7c0.4-11.7,9.5-20.8,21.5-20.4c12,0.4,20.6,9.9,20.2,21.7 S560.7,328.7,548.7,328.3z M549.7,294.8c-7.6-0.2-13.5,4.6-13.8,12c-0.2,7.4,5.4,12.6,13,12.8c7.6,0.2,13.5-4.6,13.8-12 C562.9,300.3,557.3,295.1,549.7,294.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M528.8,280.8l-2-14.1c-1.2-8.2,2-15.5,11.4-16.9s14.5,4.9,15.7,13.1l0.8,5.9l13.2-1.9l1.2,8.3L528.8,280.8z M546.6,264.1c-0.6-4.1-2.8-6.4-7.2-5.8c-4.5,0.6-5.8,3.6-5.3,7.6l0.8,5.6l12.5-1.8L546.6,264.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M523.6,247.3l-7.6-25.8l7-2.1l5.3,17.8l8.9-2.7l-4.6-15.6l6.9-2l4.6,15.6l9.1-2.7l-5.5-18.6l7-2.1l7.9,26.6 L523.6,247.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M513.7,215.3l-6.4-13.6c-3.5-7.5-2.9-15.3,5.7-19.4c5.6-2.6,10.5-1.3,14.1,2.1l10-14.9l4.1,8.7l-9.3,13.5 l2.3,4.8l12.8-6l3.6,7.6L513.7,215.3z M525,193.6c-1.8-3.7-4.3-5.4-8.4-3.5c-4.1,1.9-4.3,5.1-2.6,8.7l2.7,5.8l11-5.2L525,193.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_187_",
    gradientUnits: "userSpaceOnUse",
    x1: 442.0943,
    y1: 279.2057,
    x2: 508.438,
    y2: 279.2057
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80BC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDE021"
    }
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "st187",
    points: "508.4,320.8 442.1,320.8 442.1,237.6 508.4,237.6 483.7,279.2 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_188_",
    gradientUnits: "userSpaceOnUse",
    x1: 1550.0944,
    y1: 279.2057,
    x2: 1616.438,
    y2: 279.2057,
    gradientTransform: "matrix(-1 0 0 1 1708 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE021"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#EEDC1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#C7D013"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9482,
    style: {
      stopColor: "#88BE02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#80BC00"
    }
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "st188",
    points: "91.6,320.8 157.9,320.8 157.9,237.6 91.6,237.6 116.3,279.2 "
  }))), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "st189",
    points: "468.1,259.4 438,238.4 438,259.4 "
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "st190",
    points: "131.9,259.4 162,238.4 162,259.4 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_189_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.8681,
    y1: 181.871,
    x2: 418.1339,
    y2: 418.1368
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2145,
    style: {
      stopColor: "#0075C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7067,
    style: {
      stopColor: "#80BC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDE021"
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st191",
    d: "M448.8,213L301,127.6l-1-0.6l-1,0.6l-147,84.9l-0.8,0.5l-1,0.6v173l1,0.6L299,472.4l1,0.6l1-0.6l145.9-84.2 l2-1.1l1-0.6v-173L448.8,213z M285.2,149.2l-36.1,62.6h-72.3L285.2,149.2z M243.1,222.1l-17,29.4l-50.9-29.4H243.1z M229.9,265.5 l59.8,34.5l-59.8,34.5L210,300L229.9,265.5z M221,260.3l-17,29.4L170.2,231L221,260.3z M162,237.4l36.1,62.6L162,362.6V237.4z M204.1,310.3l17,29.4L170.2,369L204.1,310.3z M226.2,348.6l17,29.4h-67.8L226.2,348.6z M176.8,388.2h72.3l36.1,62.6L176.8,388.2z M294.9,447l-33.9-58.7h33.9V447z M294.9,377.9H255l-19.9-34.5l59.8-34.5V377.9z M294.9,291.1l-59.8-34.5l19.9-34.5h39.9V291.1z M294.9,211.8h-33.9l33.9-58.7V211.8z M379,260.3l50.9-29.4l-33.9,58.7L379,260.3z M390,300l-19.9,34.5L310.3,300l59.8-34.5 L390,300z M373.8,251.4l-17-29.4h67.8L373.8,251.4z M423.2,211.8h-72.3l-36.1-62.6L423.2,211.8z M305.1,153l33.9,58.7h-33.9V153z M305.1,222.1H345l19.9,34.5l-59.8,34.5V222.1z M305.1,308.9l59.8,34.5L345,377.9h-39.9V308.9z M305.1,388.2h33.9L305.1,447V388.2z M314.8,450.8l36.1-62.6h72.3L314.8,450.8z M356.9,377.9l17-29.4l50.9,29.4H356.9z M379,339.7l17-29.4l33.9,58.7L379,339.7z M438,362.6L401.9,300l36.1-62.6V362.6z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M300,185c1.9,0,3.8,0.5,5.4,1.5l90.1,52c0.2,0.1,0.4,0.3,0.7,0.4c0.1,0,0.1,0.1,0.2,0.1 c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.2,0.1,0.2,0.2c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1 c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.2c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1 c1.9,2,2.9,4.6,2.9,7.4V352c0,0.7-0.1,1.3-0.2,2c0,0,0,0,0,0c-0.1,0.3-0.1,0.7-0.2,1c0,0.1,0,0.1-0.1,0.2c0,0,0,0,0,0 c-0.1,0.3-0.2,0.7-0.4,1c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.2-0.2,0.4-0.3,0.6c0,0-0.1,0.1-0.1,0.1 c-0.1,0.1-0.2,0.3-0.2,0.4c-0.1,0.2-0.2,0.3-0.3,0.5c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c-0.4,0.6-0.9,1.1-1.4,1.6 c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c-0.2,0.2-0.4,0.4-0.7,0.6c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0-0.1,0.1-0.1,0.1c-0.3,0.2-0.6,0.4-0.9,0.6l-90.1,52.1c-0.3,0.2-0.5,0.3-0.8,0.4c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.1-0.3,0.1-0.5,0.1 c-0.1,0-0.1,0-0.2,0.1c-0.2,0.1-0.4,0.1-0.7,0.2c-0.1,0-0.3,0.1-0.4,0.1c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0.1-0.6,0.1 c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c-0.3,0-0.5,0-0.8,0c-1.9,0-3.8-0.5-5.4-1.5l-90.1-52.1c-0.3-0.2-0.6-0.3-0.8-0.5 c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.2-0.5-0.4-0.7-0.6c0,0,0,0-0.1-0.1c-0.2-0.2-0.4-0.4-0.6-0.6c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0 c-0.2-0.2-0.4-0.5-0.6-0.7c0,0,0,0,0,0c-1.4-1.9-2.2-4.2-2.2-6.6V247.9c0-3.9,2.1-7.5,5.4-9.4l0.3-0.1l0,0l89.9-51.9 c0.3-0.2,0.6-0.3,1-0.5c0.1,0,0.1-0.1,0.2-0.1c0.3-0.1,0.6-0.3,1-0.4c0.1,0,0.1,0,0.2,0c0.3-0.1,0.7-0.2,1-0.3c0,0,0,0,0.1,0 c0.3-0.1,0.7-0.1,1-0.2c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0C299.4,185,299.7,185,300,185 M300,175.8c-0.5,0-1,0-1.5,0.1 c-0.1,0-0.1,0-0.2,0l-0.2,0l-0.2,0l-0.3,0l-0.1,0c-0.6,0.1-1.1,0.1-1.6,0.3l-0.2,0l-0.1,0c-0.5,0.1-1.1,0.3-1.6,0.4 c-0.1,0-0.2,0.1-0.3,0.1l0,0l0,0c-0.6,0.2-1.2,0.4-1.8,0.7c-0.1,0.1-0.2,0.1-0.3,0.1c-0.7,0.3-1.3,0.6-1.8,0.9l-89.9,51.9 l-0.3,0.2c-6.2,3.6-10,10.2-10,17.4V352c0,4.3,1.4,8.6,4,12.1l0,0l0.1,0.1c0,0,0,0,0,0l0.1,0.1l0,0c0.3,0.4,0.6,0.8,1,1.2l0,0l0,0 l0,0l0,0c0.1,0.1,0.1,0.2,0.2,0.2c0.4,0.4,0.8,0.8,1.2,1.2l0.1,0.1c0.4,0.4,0.8,0.7,1.3,1.1c0.1,0.1,0.2,0.2,0.3,0.2 c0.6,0.4,1,0.7,1.5,1l90.2,52.1c3.1,1.8,6.5,2.7,10,2.7c0.5,0,0.9,0,1.4,0c0.1,0,0.3,0,0.4,0c0.4,0,0.7-0.1,1-0.1 c0.1,0,0.3,0,0.4-0.1l0.1,0l0.1,0c0.2,0,0.5-0.1,0.7-0.1l0,0l0.1,0c0.4-0.1,0.9-0.2,1.2-0.3c0.1,0,0.2-0.1,0.4-0.1l0,0 c0.3-0.1,0.5-0.2,0.8-0.2c0.2-0.1,0.3-0.1,0.5-0.2c0.2-0.1,0.4-0.1,0.5-0.2l0,0l0.1,0c0.2-0.1,0.3-0.1,0.5-0.2l0,0l0,0 c0.1-0.1,0.3-0.1,0.4-0.2l0,0l0,0c0,0,0.1,0,0.1,0l0.2-0.1l0,0c0.4-0.2,0.8-0.4,1.2-0.7l90.1-52.1c0.6-0.3,1.1-0.7,1.7-1.1 c0,0,0,0,0.1,0l0.3-0.2l0.2-0.2c0,0,0.1-0.1,0.1-0.1c0.3-0.2,0.7-0.5,1.1-0.9c0.1-0.1,0.1-0.1,0.2-0.2l0.2-0.2l0-0.1 c0.8-0.8,1.6-1.7,2.3-2.7c0.1-0.1,0.1-0.2,0.2-0.3c0.2-0.3,0.4-0.6,0.5-0.8l0,0c0.2-0.3,0.3-0.5,0.5-0.8c0-0.1,0.1-0.2,0.2-0.3 c0.2-0.3,0.3-0.6,0.5-0.9l0,0c0.1-0.2,0.2-0.3,0.2-0.5c0-0.1,0.1-0.2,0.1-0.3c0.3-0.6,0.5-1.2,0.7-1.8c0-0.1,0.1-0.2,0.1-0.3 c0.2-0.6,0.3-1.3,0.5-1.9l0-0.1l0-0.1c0.2-1.2,0.3-2.4,0.3-3.5V247.9c0-5.1-1.9-9.9-5.4-13.7l-0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.3 c-0.1-0.1-0.2-0.2-0.2-0.2c-0.1-0.1-0.3-0.3-0.5-0.4c-0.1-0.1-0.3-0.2-0.4-0.3l0,0c-0.1-0.1-0.1-0.1-0.2-0.2l0,0 c-0.1-0.1-0.2-0.2-0.3-0.3l-0.4-0.4l-0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1-0.1-0.3-0.2-0.4-0.3c-0.4-0.3-0.8-0.5-1.2-0.8 l-90.1-52C307,176.8,303.5,175.8,300,175.8L300,175.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_190_",
    d: "M294.6,186.5l-90.1,52c-3.4,1.9-5.4,5.5-5.4,9.4V352c0,3.9,2.1,7.5,5.4,9.4l90.1,52.1 c3.4,1.9,7.5,1.9,10.9,0l90.1-52.1c3.4-1.9,5.4-5.5,5.4-9.4V247.9c0-3.9-2.1-7.5-5.4-9.4l-90.1-52c-1.7-1-3.6-1.5-5.4-1.5 C298.1,185,296.3,185.5,294.6,186.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_191_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_190_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_192_",
    gradientUnits: "userSpaceOnUse",
    x1: 787.5618,
    y1: -1220.3075,
    x2: 788.9013,
    y2: -1220.3075,
    gradientTransform: "matrix(-60.7992 124.0303 124.0303 60.7992 199574.9531 -23262.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "st192",
    points: "492.1,229.7 361.9,495.3 107.9,370.8 238.1,105.2 "
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_193_",
    d: "M201.2,358.7c0.9,1.1,1.9,2.1,3.2,2.8l77.5,44.8l12.7,7.3c1.9,1.1,4.1,1.6,6.2,1.4 c0.8-0.1,1.5-0.2,2.2-0.4l95.1-174.1c-0.7-0.8-1.6-1.5-2.5-2l-59.1-34.1l-31.1-17.9c-0.9-0.5-1.8-0.9-2.8-1.1L201.2,358.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_194_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_193_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_195_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.7186,
    y1: -1247.359,
    x2: 730.058,
    y2: -1247.359,
    gradientTransform: "matrix(170.598 -126.0469 -126.0469 -170.598 -281258.4062 -120633.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3907,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FBE4A"
    }
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "st193",
    points: "91.4,266.5 328.6,91.2 507.9,334 270.7,509.2 "
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_196_",
    d: "M294.6,186.5l-90.1,52c-3.4,1.9-5.4,5.5-5.4,9.4V352c0,3.9,2.1,7.5,5.4,9.4l90.1,52.1 c3.4,1.9,7.5,1.9,10.9,0l90.1-52.1c3.4-1.9,5.4-5.5,5.4-9.4V247.9c0-3.9-2.1-7.5-5.4-9.4l-90.1-52c-1.7-1-3.6-1.5-5.4-1.5 C298.1,185,296.3,185.5,294.6,186.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_197_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_196_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st194"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_198_",
    points: "291.6,167.3 290.3,168.1 292,168.1 "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_199_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_198_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st195"
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_200_",
    x: 290.3,
    y: 167.3,
    width: 1.7,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_201_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_200_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_202_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.7328,
    y1: -1264.83,
    x2: 742.0723,
    y2: -1264.83,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196639.0781)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 290.3,
    y: 167.3,
    className: "st196",
    width: 1.7,
    height: 0.7
  }))))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_203_",
    d: "M299,185.1c-1.5,0.1-3,0.6-4.4,1.4l-89.9,51.9l96.9,176.5c1.3-0.2,2.7-0.6,3.9-1.3l90.1-52.1 c2.8-1.6,4.7-4.3,5.3-7.4L302,185.2c-0.7-0.1-1.5-0.2-2.2-0.2C299.5,185,299.3,185,299,185.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_204_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_203_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_205_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.7328,
    y1: -1265.0454,
    x2: 742.0723,
    y2: -1265.0454,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196540.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 204.7,
    y: 185,
    className: "st197",
    width: 196.2,
    height: 229.9
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_206_",
    d: "M294.6,186.5l-90.1,52c-3.4,1.9-5.4,5.5-5.4,9.4V352c0,3.9,2.1,7.5,5.4,9.4l90.1,52.1 c3.4,1.9,7.5,1.9,10.9,0l90.1-52.1c3.4-1.9,5.4-5.5,5.4-9.4V247.9c0-3.9-2.1-7.5-5.4-9.4l-90.1-52c-1.7-1-3.6-1.5-5.4-1.5 C298.1,185,296.3,185.5,294.6,186.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_207_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_206_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st198"
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_208_",
    points: "404.2,359.8 403.6,358.8 403.6,360.1 "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_209_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_208_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st199"
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_210_",
    x: 403.6,
    y: 358.8,
    width: 0.6,
    height: 1.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_211_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_210_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_212_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.7328,
    y1: -1265.1423,
    x2: 742.0723,
    y2: -1265.1423,
    gradientTransform: "matrix(155.5994 0 0 -155.5994 -115061.7891 -196495.9219)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 403.6,
    y: 358.8,
    className: "st200",
    width: 0.6,
    height: 1.4
  }))))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_213_",
    d: "M294.6,186.5l-90.1,52c-3.4,1.9-5.4,5.5-5.4,9.4V352c0,3.9,2.1,7.5,5.4,9.4l90.1,52.1 c3.4,1.9,7.5,1.9,10.9,0l90.1-52.1c3.4-1.9,5.4-5.5,5.4-9.4V247.9c0-3.9-2.1-7.5-5.4-9.4l-90.1-52c-1.7-1-3.6-1.5-5.4-1.5 C298.1,185,296.3,185.5,294.6,186.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_214_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_213_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st201"
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_215_",
    d: "M395.8,361.5l-90.2,52.1c-1.2,0.7-2.6,1.2-4,1.4l2.4,3.3l100.9-58v-1.4l-3.1-4.2 C401,357.4,398.4,359.9,395.8,361.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_216_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_215_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st202"
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_217_",
    x: 301.6,
    y: 354.5,
    width: 103.3,
    height: 63.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_218_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_217_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_219_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.8254,
    y1: -1264.7571,
    x2: 742.1649,
    y2: -1264.7571,
    gradientTransform: "matrix(157.5199 0 0 -157.5199 -116500.2969 -198838.1094)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    style: {
      stopColor: "#6FBE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    style: {
      stopColor: "#68B548"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#569E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#438740"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 301.6,
    y: 354.5,
    className: "st203",
    width: 103.3,
    height: 63.6
  }))))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_220_",
    d: "M294.6,186.5l-90.1,52c-3.4,1.9-5.4,5.5-5.4,9.4V352c0,3.9,2.1,7.5,5.4,9.4l90.1,52.1 c3.4,1.9,7.5,1.9,10.9,0l90.1-52.1c3.4-1.9,5.4-5.5,5.4-9.4V247.9c0-3.9-2.1-7.5-5.4-9.4l-90.1-52c-1.7-1-3.6-1.5-5.4-1.5 C298.1,185,296.3,185.5,294.6,186.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_221_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_220_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st204"
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_222_",
    d: "M395.8,361.5l-90.2,52.1c-1.2,0.7-2.6,1.2-4,1.4l2.4,3.3l100.9-58v-1.4l-3.1-4.2 C401,357.4,398.4,359.9,395.8,361.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_223_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_222_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st205"
  }, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_224_",
    x: 301.9,
    y: 326,
    transform: "matrix(0.4402 -0.8979 0.8979 0.4402 -149.1581 533.4676)",
    width: 102.6,
    height: 120.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_225_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_224_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_226_",
    gradientUnits: "userSpaceOnUse",
    x1: 773.1926,
    y1: -1223.7617,
    x2: 774.532,
    y2: -1223.7617,
    gradientTransform: "matrix(-95.9638 195.7662 195.7662 95.9638 314204.4375 -33708.0664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#438740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#438B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#429644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#40A948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40AD49"
    }
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    className: "st206",
    points: "487.4,341.9 400.3,519.7 219,430.8 306.2,253 "
  })))))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st207",
    cx: 300,
    cy: 300,
    r: 200.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_227_",
    gradientUnits: "userSpaceOnUse",
    x1: 468.7226,
    y1: 300.9902,
    x2: 136.9357,
    y2: 300.9902
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80BC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDE021"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 131.9,
    y: 259.4,
    className: "st208",
    width: 336.2,
    height: 83.2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M160,299.6c0-12.2,9.3-20.8,20.9-20.8c7.2,0,12.7,2.7,16.1,7.9l-3.3,2.4c-2.6-3.9-7-6.4-12.8-6.4 c-9.5,0-16.4,7.2-16.4,16.9c0,9.7,6.9,16.9,16.4,16.9c5.9,0,10.5-2.6,13.4-6.8l3.3,2.3c-3.6,5.3-9.4,8.4-16.7,8.4 C169.3,320.4,160,311.8,160,299.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M205.7,279.3h24.7v3.8H210v14.5h18.2v3.8H210v14.7h21.3v3.8h-25.6V279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M240.3,279.3h12.2c8.5,0,14.5,4,14.5,12.4c0,6-3.3,9.9-8.5,11.5l9.9,16.7h-5.1l-9.3-16 c-0.6,0.1-1.3,0.1-1.9,0.1h-7.4v16h-4.3V279.3z M252.3,300.2c6.6,0,10.2-2.8,10.2-8.5c0-5.9-3.6-8.6-10.2-8.6h-7.6v17.1H252.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M284.3,283.1h-12.5v-3.8h29.3v3.8h-12.5v36.8h-4.3V283.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M308.8,279.3h4.4v40.6h-4.4V279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M324.5,279.3h24.4v3.8h-20.1v15.5h18.3v3.9h-18.3v17.4h-4.3V279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M357.9,279.3h4.4v40.6h-4.4V279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M373.5,279.3h24.7v3.8h-20.4v14.5h18.2v3.8h-18.2v14.7h21.3v3.8h-25.6V279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M408.2,279.3h9.9c13.6,0,22,8,22,20.3c0,12.3-8.4,20.3-22,20.3h-9.9V279.3z M417.7,316 c12,0,17.7-6.8,17.7-16.4c0-9.7-5.7-16.4-17.7-16.4h-5.3V316H417.7z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.4a6c2226287fefe357de70d7ae657a17.svg";
export { ForwardRef as ReactComponent };